import { ReactNode } from 'react';
import clsx from 'clsx';
import { Message } from '@rossum/api-client/shared';
import { Box, Tooltip, tooltipClasses } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { MessageDetailLinks } from '../../../features/annotation-view/document-sidebar/sidebar-items/shared/MessageDetailLinks';
import HTMLMessage from '../../DatapointMessage/HTMLMessage';
import IconWithTooltip from '../../DatapointMessage/IconWithTooltip';
import styles from '../style.module.sass';

type Props = {
  active?: boolean;
  children: (_: { messageIcon: ReactNode }) => JSX.Element;
  hideBorder?: boolean;
  inFooter?: boolean;
  isButton?: boolean;
  message?: Message | null;
  renderEmptyPlaceholder?: boolean;
  resizing?: boolean;
};

const DatapointMessage = ({
  active = false,
  children,
  hideBorder = false,
  // this name is not accurate anymore and it is tricky because
  // the component is being used also as an indicator
  // on the row&table header in line items
  inFooter = false,
  isButton = false,
  message = null,
  renderEmptyPlaceholder,
  resizing = false,
}: Props) =>
  inFooter ? (
    <Tooltip
      open={active && !resizing}
      placement="top"
      slotProps={{
        tooltip: {
          sx: {
            [`&.${tooltipClasses.tooltip}`]: {
              backgroundColor: t =>
                message ? t.palette[message.type].main : undefined,
              color: t =>
                message ? t.palette[message.type].contrastText : undefined,
              fontSize: t => t.typography.pxToRem(14),
              textAlign: 'left',
              px: 2,
              py: 1,
            },
          },
        },
        popper: {
          sx: {
            zIndex: 100,
          },
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -12],
              },
            },
          ],
        },
      }}
      title={
        message?.id ? (
          <>
            <HTMLMessage content={message?.content || ''} />
            <MessageDetailLinks detail={message?.detail} />
          </>
        ) : (
          ''
        )
      }
      arrow={false}
    >
      <Box
        className={clsx(!isButton && styles['Cell'])}
        borderColor={
          message && !hideBorder ? `${message.type}.main` : undefined
        }
        sx={{ borderRadius: borderRadius('s') }}
      >
        {children({ messageIcon: null })}
      </Box>
    </Tooltip>
  ) : (
    children({
      messageIcon: message ? (
        // eslint-disable-next-line no-restricted-syntax
        <IconWithTooltip message={message} active={!!active} />
      ) : renderEmptyPlaceholder ? (
        <div className={styles['EmptyIconPlaceholder']} />
      ) : null,
    })
  );

export default DatapointMessage;
